<h2 mat-dialog-title>Session expired!</h2>
<div mat-dialog-content>
  <p>Session expired due to inactivity. Click to Log in again.</p>
</div>
<div mat-dialog-actions align="end">
  <button
    (click)="logInAgain()"
    class="btn btn-sm btn-outline-success"
  >
    Log in
  </button>
</div>
